<mat-card-content class="w-100-p mb-0">
    <div class="p-24 stats-wrapper">
        <div class="chart-wrapper w-100-p" fxLayoutAlign="space-between center" *ngIf="horizontalView; else verticalView">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper w-100-p">
                <div fxLayout="row">
                    <div
                        fxLayoutAlign="center center"
                        class="icon-wrapper mr-8"
                        [ngStyle]="{
                            background: '#FBE78D',
                            fill: '#f5af40'
                        }"
                    >
                        <mat-icon svgIcon="certificate_color"></mat-icon>
                    </div>
                    <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                        {{ 'PAGE.CERTIFICATIONS.TITLE' | translate }}
                    </label>
                </div>

                <div class="learning-time-container horizontal">
                    <span tabindex="0">{{ totalCount }}&nbsp;</span>
                    <span>{{ 'PAGE.CERTIFICATIONS.TITLE' | translate }}</span>
                </div>
            </div>
        </div>

        <ng-template #verticalView>
            <div fxLayout="column" class="chart-wrapper w-100-p">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper mb-8 w-100-p">
                    <div class="w-100-p" fxLayoutAlign="space-between center">
                        <div fxLayout="row">
                            <div
                                fxLayoutAlign="center center"
                                class="icon-wrapper mr-8"
                                [ngStyle]="{
                                    background: '#FBE78D',
                                    fill: '#f5af40'
                                }"
                            >
                                <mat-icon svgIcon="certificate_color"></mat-icon>
                            </div>
                            <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                                {{ 'PAGE.CERTIFICATIONS.TITLE' | translate }}
                            </label>
                        </div>
                        <div fxLayoutAlign="flex-end center">
                            <div class="bg-[#AF2F21] rounded-full pt-0.5 pr-1.5 pb-[3px] pl-[9px] mr-8" *ngIf="expiredCount">
                                <span class="text-white text-xs" tabindex="0">{{ expiredCount }}&nbsp;</span>
                            </div>
                            <mat-icon svgIcon="right_arrow"></mat-icon>
                        </div>
                    </div>
                </div>

                <div
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxFlex="1 1 auto"
                    class="bg-zinc-50 text-xs leading-5 min-w-2 text-gray-600 text-center tracking-widest uppercase"
                >
                    <span tabindex="0">{{ totalCount }}&nbsp;</span>
                    <span>{{ 'PAGE.CERTIFICATIONS.TITLE' | translate }}</span>
                </div>
            </div>
        </ng-template>
    </div>
</mat-card-content>
